import React from 'react';
import { styled, SubTitle, Shape, Dropdown } from '@teko/ds-desktop';
import { MoreInforOutlined, ChevronLeftFilled } from '@teko/ds-icon';
import Head from 'next/head';
import TerraKit from '@terra-js/terra-kit';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavBar = styled.div`
  display: flex;
  height: 3.5rem;
  background: #fff;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
  &.detail {
    box-shadow: none;
  }
`;
const Center = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledSubTitle = styled(SubTitle)`
  ${(props) => props.line ? `text-overflow: ellipsis;` : ``}
`;
const Left = styled.div((props) => ({
  minWidth: "3.5rem",
  height: "3.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  visibility: props.visible ? "visible" : "hidden"
}));
const Right = styled.div`
  min-width: 3.5rem;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledIcon = styled(MoreInforOutlined)`
  display: block;
`;
const NavBar = (_a) => {
  var _b = _a, {
    title,
    goBack,
    right,
    toggleType = "click",
    dropdownMenu,
    isTitleMoreThan2Line = false,
    iconBack
  } = _b, props = __objRest(_b, [
    "title",
    "goBack",
    "right",
    "toggleType",
    "dropdownMenu",
    "isTitleMoreThan2Line",
    "iconBack"
  ]);
  const onlyTitle = !goBack && !right && !dropdownMenu;
  return /* @__PURE__ */ React.createElement(StyledNavBar, __spreadValues({}, props), !onlyTitle && /* @__PURE__ */ React.createElement(Left, {
    visible: !!goBack
  }, iconBack || /* @__PURE__ */ React.createElement(ChevronLeftFilled, {
    size: 24,
    onClick: goBack,
    color: "#333"
  })), /* @__PURE__ */ React.createElement(Center, null, isTitleMoreThan2Line ? title : /* @__PURE__ */ React.createElement(StyledSubTitle, {
    level: 2,
    line: 1
  }, title)), !onlyTitle && /* @__PURE__ */ React.createElement(Right, null, right, dropdownMenu && /* @__PURE__ */ React.createElement(Shape, {
    padding: "s8"
  }, /* @__PURE__ */ React.createElement(Dropdown, {
    trigger: toggleType,
    menu: dropdownMenu
  }, /* @__PURE__ */ React.createElement(StyledIcon, {
    size: 20,
    color: "#333"
  })))), !!TerraKit.isAvailable() && /* @__PURE__ */ React.createElement(Head, null, /* @__PURE__ */ React.createElement("title", null, title)));
};

export { NavBar };
